// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__36pJY","fileDisabled":"File_fileDisabled__2hY1f"};